export default __webpack_public_path__ + "static/media/CNo.82-3.0394476f.jpg";